module.exports = __webpack_public_path__ + "static/Srikanth_Sheshadri-8372a0a0ef99ab8a13c104f5e8d77bf4.jpg";